function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/****

ref

https://www.w3.org/TR/wai-aria-practices-1.1/examples/tabs/tabs-1/tabs.html
https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-1/js/tabs.js

EXAMPLE HTML

<div class="tabs">
	<div role="tablist" aria-label="Title">
		<button role="tab" aria-selected="true" aria-controls="tab-1" id="btn-1">Label 1</button>
		<button role="tab" aria-selected="false" aria-controls="tab-1" id="btn-1">Label 1</button>
		...
	</div>

	<div tabindex="0" role="tabpanel" id="tab-1" aria-labelled-by="btn-1">...</div>
	<div tabindex="0" role="tabpanel" id="tab-1" aria-labelled-by="btn-1" hidden="hidden">...</div>
	...
</div>
***/
import { keys } from 'util'; // TODO
// only works for 1 [role="tabllist"] right now
// allyjs focus

var Tabs = /*#__PURE__*/function () {
  function Tabs(tablist) {
    var _this = this;

    _classCallCheck(this, Tabs);

    this.tablist = tablist; // if (!this.tablist || this.tablist.length === 0) return;

    this.tabs = Array.from(this.tablist.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.tablist.querySelectorAll('[role="tabpanel"]')); //
    // this.tabs = Array.from(document.querySelectorAll('[role="tab"]'))
    // this.panels = Array.from(document.querySelectorAll('[role="tabpanel"]'))

    this.tabs.forEach(function (tab, i) {
      tab.index = i;

      _this.bindEventHandlers(tab);
    });
  }

  _createClass(Tabs, [{
    key: "bindEventHandlers",
    value: function bindEventHandlers(tab) {
      tab.addEventListener('click', this.handleTabClick.bind(this));
      tab.addEventListener('keydown', this.handleTabKeyDown.bind(this));
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(evt) {
      evt.preventDefault();
      this.activateTab(evt.target, false);
    }
  }, {
    key: "handleTabKeyDown",
    value: function handleTabKeyDown(evt) {
      var isVertical = evt.target.closest('[role="tablist"]').getAttribute('aria-orientation') == "vertical";

      switch (evt.keyCode) {
        case keys.LEFT_ARROW:
        case keys.UP_ARROW:
        case keys.RIGHT_ARROW:
        case keys.DOWN_ARROW:
          this.determineOrientation(evt);
          break;

        case keys.HOME:
          evt.preventDefault();
          this.activateTab(this.tabs[0]);
          break;

        case keys.END:
          evt.preventDefault();
          this.activateTab(this.tabs[this.tabs.length - 1]);
          break;
      }
    }
  }, {
    key: "determineOrientation",
    value: function determineOrientation(evt) {
      var isVertical = evt.target.closest('[role="tablist"]').getAttribute('aria-orientation') == "vertical";

      if (isVertical && (evt.keyCode === keys.UP_ARROW || evt.keyCode === keys.DOWN_ARROW)) {
        evt.preventDefault();
        this.switchTabOnArrowPress(evt);
      } else if ([keys.LEFT_ARROW, keys.RIGHT_ARROW].includes(evt.keyCode)) {
        this.switchTabOnArrowPress(evt);
      }
    } // checkk liberties taken
    // only fires on arrow keys, not home/end

  }, {
    key: "switchTabOnArrowPress",
    value: function switchTabOnArrowPress(evt) {
      var _this2 = this;

      this.tabs.forEach(function (x) {
        return x.addEventListener('focus', _this2.handleFocus.bind(_this2));
      });
      var dir = [keys.LEFT_ARROW, keys.UP_ARROW].includes(evt.keyCode) ? -1 : 1;

      if (this.tabs[evt.target.index + dir]) {
        this.tabs[evt.target.index + dir].focus();
      } else if (evt.keyCode === keys.LEFT_ARROW || evt.keyCode === keys.UP_ARROW) {
        this.focusLastTab();
      } else if (evt.keyCode === keys.RIGHT_ARROW || evt.keyCode === keys.DOWN_ARROW) {
        this.focusFirstTab();
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(evt) {
      if (evt.target === document.activeElement) {
        this.activateTab(evt.target);
      }
    }
  }, {
    key: "activateTab",
    value: function activateTab(tab) {
      var setFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.deactivateTabs();
      tab.removeAttribute('tabindex');
      tab.setAttribute('aria-selected', "true");
      var ctrls = tab.getAttribute('aria-controls');
      var panel = this.panels.find(function (x) {
        return x.id == ctrls;
      });
      panel.removeAttribute('hidden');
      panel.setAttribute('aria-expanded', "true"); // TODO
      // force focus if not focusable?
      // ally?

      if (setFocus) {
        tab.focus();
      }
    }
  }, {
    key: "deactivateTabs",
    value: function deactivateTabs() {
      var _this3 = this;

      this.tabs.forEach(function (tab) {
        tab.setAttribute('tabindex', "-1");
        tab.setAttribute('aria-selected', "false");
        tab.removeEventListener('focus', _this3.handleFocus);
      });
      this.panels.forEach(function (panel) {
        panel.setAttribute('hidden', "hidden");
        panel.setAttribute('aria-expanded', "false");
      });
    }
  }, {
    key: "focusFirstTab",
    value: function focusFirstTab() {
      this.tabs[0].focus();
    }
  }, {
    key: "focusLastTab",
    value: function focusLastTab() {
      this.tabs[this.tabs.length - 1].focus();
    }
  }]);

  return Tabs;
}();

export { Tabs as default };